import gradient1 from "./Gradient-1.svg";
import gradient2 from "./Gradient-2.png";
import gradient3 from "./Gradient-3.svg";
import gradient4 from "./Gradient-4.svg";
import gradient5 from "./Gradient-5.svg";
import gradient6 from "./Gradient-6.svg";
import gradient7 from "./Gradient-7.svg";
import gradient8 from "./Gradient-8.svg";
import gradient9 from "./Gradient-9.svg";
import gradient10 from "./Gradient-10.svg";

export const gradients = {
  gradient1,
  gradient2,
  gradient3,
  gradient4,
  gradient5,
  gradient6,
  gradient7,
  gradient8,
  gradient9,
  gradient10,
};
